import { c as _c } from "react/compiler-runtime";
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { Paper } from '@mui/material';
import type { ReactNode } from 'react';
export function ListContainer(props) {
  const $ = _c(13);
  const {
    children
  } = props;
  const possibleArrayChildren = children as {
    props: {
      children: {
        key: string;
      }[];
    };
  };
  if (!possibleArrayChildren || !possibleArrayChildren.props?.children || !Array.isArray(possibleArrayChildren?.props?.children)) {
    let t0;
    if ($[0] !== children || $[1] !== props) {
      t0 = <Paper {...props}>{children}</Paper>;
      $[0] = children;
      $[1] = props;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  let t0;
  if ($[3] !== possibleArrayChildren.props.children) {
    t0 = possibleArrayChildren.props.children.map(_temp);
    $[3] = possibleArrayChildren.props.children;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const offerIds = t0;
  let t1;
  if ($[5] !== offerIds) {
    t1 = {
      marketplace_product_type: "credit_cards",
      marketplace_offer_ids: offerIds,
      marketplace_offers_count: offerIds.length
    };
    $[5] = offerIds;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== children || $[8] !== props) {
    t2 = <Paper {...props}>{children}</Paper>;
    $[7] = children;
    $[8] = props;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <FeatureViewed entityName="credit_card_search" entitySection="cc_compare_search" impressionPosition={1} additionalAttributes={t1}>{t2}</FeatureViewed>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
function _temp(el) {
  return el?.key;
}